//import "bootstrap";
import "./scss/index_2022.scss";
//import ScrollOut from "scroll-out";
import "scroll-out";

import "./util"

import "./freespace-slideanimation"
import "./application";
import "./splash";
import "./boilerplate/index_new.js";

// import Swiper bundle with all modules installed
import Swiper from 'swiper/bundle';

export const mySwiper = Swiper;
const sha1 = require("crypto-js/sha1");

const js_cookie = require('js-cookie');


if (history.scrollRestoration) {
    history.scrollRestoration = 'manual';
}



window.bootstrap = require('bootstrap/dist/js/bootstrap.bundle.js');
window.js_cookie = js_cookie;
export const hash_string = (source_string) =>{
    
    let result = sha1(source_string);
    return result;
}



(function () {
    window.addEventListener('DOMContentLoaded', function (event) {
        ScrollOut({
            onShown(el) {
                
                el.classList.add("animate__fadeIn");
            }
        });
    });
})();






export const init_swiper = () => {
    //(window.innerWidth - 300) / (1920 - 300) + 1
    let speed = ((window.innerWidth - 300) / (1920 - 300) + 1 ) * 15000
    const swiper = new Swiper('.cases', {
        // Optional parameters
        loop: true,
        slidesPerView:1.5,
        freeMode:true,
        centeredSlides:true,
        speed: speed, // Uniform time
        autoplay: {
            delay: 0,
            stopOnLastSlide: false,
            disableOnInteraction: true,
        },
        // If we need pagination
        pagination: {
            el: '.swiper-pagination',
        },

        // Navigation arrows
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },

        // And if we need scrollbar
        scrollbar: {
            el: '.swiper-scrollbar',
        },
    });
    return swiper;
}


